


































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import { formatJson, resetObjValue2NoneString } from '@/utils/tool'
import { exportJson2Excel } from '@/utils/excel'
import moment from 'moment'
import { dataCenterIos, dataCenterAndroid, dataCenterBanner, dataCenterSpecial, getBannerData, getSpecialData } from '@/api/datas/content'

@Component({
  name: 'DatasContent'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    lang: '',
    entityType: '',
    reportDateStart: '',
    reportDateEnd: '',
    entityId: '', // 应用 ID
    orderBy: '', // 排序方式 （例子：按下载量倒序“download_count desc”，按下载量顺序“download_count”）
    page: 1,
    pageCount: 20
  }

  private tableHeight: number = 500

  // template data
  private channels: any[] = [] // 级联选择
  private positions: any = {
    banner: [],
    special: []
  } // 位置选项
  private langs: string[] = []
  private value: any[] = [] // 级联选中项
  private position: any[] = [] // 级联选中项
  private dateArray: string[] = ['', '']
  private tableData: any[] = []
  private totalCount: number = 0
  private area: string = 'banner'
  tableLoading = false
  // lifecycle
  created() {
    const { query } = this.$route
    if (query.area) {
      this.area = query.area as string
    }
    this.getOptions()
    this.getTableData()
  }

  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }

  updated() {
    this.$nextTick(() => {
      const table: any = this.$refs.tableRef
      table.doLayout()
    })
  }

  // methods
  setTableHeight() {
    const table: any = this.$refs.tableRef
    const tableDom: HTMLTableElement = table.$el
    const { top } = tableDom.getBoundingClientRect()
    let height: number = document.body.clientHeight - top - 75
    this.tableHeight = height
  }
  async getTableData() {
    this.tableLoading = true
    let map = new Map([['special', getSpecialData], ['banner', getBannerData]])
    let func: any = map.get(this.area)
    let res: any = await func(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.pic_url = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].pic_url, header).then(res => {
        this.tableData[i]['pic_url'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  getOptions() {
    let banner: any = dataCenterBanner()
    let special: any = dataCenterSpecial()
    Promise.all([banner, special]).then((result) => {
      let [banner, special] = result
      this.positions = {
        banner: this.formatOption(banner),
        special: this.formatOption(special)
      }
      this.tableLoading = false
    }).catch((error) => {
      console.log(error)
    })
  }
  handleTabchange() {
    this.$router.push({
      query: {
        area: this.area
      }
    })
    this.handleReset()
  }
  formatDate(date: any) {
    return date.split('T')[0]
  }
  getSummaries(param: any, range: number[]) {
    const { columns, data } = param
    const sums: any[] = []
    columns.forEach((column: { property: string|number }, index: number) => {
      if (index === 0) {
        sums[index] = '总计'
      } else if (index >= range[0] && index <= range[1]) {
        const values = data.map((item: { [x: string]: any }) => Number(item[column.property]))
        if (!values.every((value: number) => isNaN(value))) {
          sums[index] = values.reduce((prev: any, curr: any) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = 0
        }
      } else {
        sums[index] = '--'
      }
    })
    return sums
  }
  formatOption({ data }: any) {
    data = data || []
    return data.map(({ code, name }: any) => ({ value: code, label: name }))
  }
  handleSelectOne(v: number[]) {
    console.log(v)
  }
  handleDateChange(date: string[]) {
    this.params.reportDateStart = date && date[0]
    this.params.reportDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    this.params = {
      lang: '',
      entityType: '',
      reportDateStart: '',
      reportDateEnd: '',
      entityId: '', // 应用 ID
      orderBy: '', // 排序方式 （例子：按下载量倒序“download_count desc”，按下载量顺序“download_count”）
      page: 1,
      pageCount: 20
    }
    this.langs = []
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleSort({ order, prop }: any) {
    if (order === '') {
      this.params.orderBy = ''
    } else if (order === 'descending') {
      this.params.orderBy = prop + ' desc'
    } else {
      this.params.orderBy = prop
    }
    this.getTableData()
  }
  handleSelect(val: string[]) {
    let copy = [...val]
    if (val.includes('all')) {
      if (copy.pop() === 'all') (this.params.lang = 'all') && (this.langs = ['all'])
      else (this.langs = val.filter(el => el !== 'all')) && (this.params.lang = this.langs.toString())
    } else this.params.lang = val.toString()
  }
  async handleExcel() {
    let map = new Map([['special', getSpecialData], ['banner', getBannerData]])
    let func: any = map.get(this.area)
    let params = { ...this.params }
    params.page = 1
    params.pageCount = 500
    let res: any = await func(params)
    if (res.status.code === 0) {
      setTimeout(() => {
        this['$message'].success('导出成功!')
      }, 200)
    } else {
      this['$message'].error('导出失败!')
      return
    }
    let list: any = res.data.dataList || []
    let filterVal: string[] = [
      'id',
      'entity_id',
      'channel_type',
      'lang',
      'pic_url',
      'desc',
      'view_count',
      'report_date'
    ]
    let theader: string[] = [
      'ID',
      'Banner ID',
      '渠道',
      '语言',
      'ICON',
      '描述',
      '查看数量',
      '统计日期'
    ]
    if (this.area !== 'banner') {
      filterVal = [
        'id',
        'entity_id',
        'channel_type',
        'lang',
        'icon',
        'name',
        'view_count',
        'comment_count',
        'favorite_count',
        'report_date'
      ]
      theader = [
        'ID',
        '专题ID',
        '渠道',
        '语言',
        '专题图',
        '专题名称',
        '查看数量',
        '评论数量',
        '收藏数量',
        '统计日期'
      ]
    }
    this.exportData(theader, filterVal, list)
  }

  exportData(theader: string[], filterVal: string[], list: any[]) {
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
  }
}
